<template>
    <el-container name="ListPage" >
        <el-aside class="hidden-sm-and-down" v-if="pageSet.leftTreePageId>0" width="200px" >
            <TreePage ref='LeftTree' 
                :leftTreePageId="pageSet.leftTreePageId" 
                :leftTreeTableId="pageSet.leftTreeTableId" 
                treeType=0
                dataMaxNumber=1
                @initSearchData="initSearchData"
            ></TreePage>
        </el-aside>
        <el-main style="padding:5px">
            <div v-if="pageSet.list_template == 'kb_list'">
                <Schedule ref='schedule_list' :initPageSet="pageSet" :initTableId="pageInfo.tableId" :initPageId="pageInfo.pageId"></Schedule>
            </div>
            <div v-else v-loading="loading">
                <div name= "searchTab">
                    <!-- 搜索条件的 折叠面板 -->
                    <el-collapse v-model="pageSet.ifUnfoldsrch" accordion>
                        <el-collapse-item title="搜索条件" name="1">
                            <!-- 搜索条件的 form表单 -->
                            <ListSearch ref='ListSearch' :searchSetArr="searchSetArr" :ifFreeTimeSearch="pageSet.ifFreeTimeSearch" 
                                @initSearchData="initSearchData"
                            ></ListSearch>
                            
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <el-button-group>
                    <el-button type="primary" @click="initSearchData" icon="el-icon-search"></el-button>
                    <el-button type="primary" 
                        v-for="(buttonSetOne,buttonSetIndex) in pageSet.buttonSet" :key="'buttonSet_'+buttonSetIndex"
                        v-if="buttonSetOne.ifShow"
                        @click="listButtonSetClick(buttonSetIndex)" 
                    >{{buttonSetOne.buttonName}}</el-button>
                </el-button-group>
                
                <div name="listDiv">
                    <!-- 列表的table信息 -->
                    <el-table v-if="fieldSet.length > 0"
                        ref="listTableRef"
                        :data="listData"
                        row-key="id"
                        border
                        highlight-current-row
                        @row-click="tableRowClick"
                        @row-dblclick="tableRowDblclick"
                        @selection-change="tableSelectionChange"
                        @sort-change="sortChange"
                        size="mini"
                        style="width: 100%;"
                        :row-style="getRowStyle"
                        :cell-style="getCellStyle"
                        :max-height="tableMaxHeight"
                        >
                        <!-- 加号展开子表格的数据 -->
                        <el-table-column v-if="pageSet.childTabs.length > 0" 
                            type="expand"
                            fixed="left"
                        >
                            <template slot-scope="props">
                                <el-tabs value="childTab_0">
                                    <el-tab-pane v-for="(childTabOne,childTabIndex) in pageSet.childTabs" :key="'childTab_'+childTabIndex"
                                        :label="childTabOne.childPageName" 
                                        :name="'childTab_'+childTabIndex"
                                    >
                                        <ListPage :initPageInfo="childTabOne" 
                                            :mainId="props.row['T_' + pageInfo.tableId + '_0']" 
                                            :sourcePageInfo="pageInfo">
                                        </ListPage>
                                    </el-tab-pane>
                                </el-tabs>
                            </template>
                        </el-table-column>
                        <el-table-column
                            type="index"
                            fixed="left"
                            :index="getListIndex"
                            width="40">
                        </el-table-column>
                        <el-table-column
                            type="selection"
                            fixed="left"
                            reserve-selection
                            width="40">
                        </el-table-column>
                        <el-table-column v-if="pageSet.operaButtonSetIfHide"
                            fixed="left"
                            label="操作"
                            width="100">
                            <template slot-scope="scope">
                                <el-dropdown v-if="pageSet.operaButtonSet.length > 1" 
                                    trigger="click" size="mini"
                                     @command="dataButtonSetClick($event,scope.row)"
                                >
                                    <el-button type="primary"
                                        size="mini"
                                    >
                                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(operaButtonOne,operaButtonIndex) in pageSet.operaButtonSet" :key="operaButtonIndex"
                                            v-if="operaButtonOne.ifShow && (scope.row[operaButtonOne.butTjKey] != 0)"
                                            :command="operaButtonOne"
                                        >
                                            {{operaButtonOne.buttonName}}
                                        </el-dropdown-item>

                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-button-group v-else>
                                    <el-button v-for="(operaButtonOne,operaButtonIndex) in pageSet.operaButtonSet" :key="operaButtonIndex"
                                        v-if="operaButtonOne.ifShow"
                                        @click="dataButtonSetClick(operaButtonOne,scope.row)" type="text" size="small"
                                    >
                                        {{operaButtonOne.buttonName}}
                                    </el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                        <div v-for="(fieldOne,fieldIndex) in fieldSet" :key="fieldIndex">
                            <el-table-column 
                               
                                :prop="(fieldOne.fieldType == 4?'DIC_':'')+fieldOne.fieldAliasName"
                                :sortable="(fieldOne.ifSort==1?'custom':false)"
                                :label="fieldOne.fieldCnName"
                                :fixed="(fieldIndex < pageSet.fixdRow)?true:false"
                                :min-width="fieldOne.listWidth+'px'"
                            >
                                <template  slot-scope="scope">
                                    <!-- 进度条的展现形式 -->
                                    <span v-if="fieldOne.showType == 1">
                                        <el-progress v-if='!isNaN(scope.row[fieldOne.fieldAliasName])' :percentage="scope.row[fieldOne.fieldAliasName]*1"></el-progress>
                                        <span v-else >{{scope.row[fieldOne.fieldAliasName]}}</span>
                                    </span>
                                    <span v-else >
                                        {{scope.row[fieldOne.fieldAliasName]}}
                                    </span>
                                </template>
                            </el-table-column>
                        </div>
                    </el-table>
                    <!-- 分页插件 -->
                    <el-pagination v-if="pageSet.ifParent != 1"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[20, 30, 40, 50]"
                        :page-size="pageSize"
                        layout="slot, total, sizes, prev, pager, next, jumper"
                        :total="totalCount">
                        <span v-if="pageSet.ifSearchCount == 1" @click="loadPageDataCount">未加载记录数信息,当前显示虚拟记录数,如需查看请点击加载</span>
                    </el-pagination>
                </div>
                <!-- 树形结构数据 
                <div v-else-if="pageSet.ifParent == 1" :style="'height:'+tableMaxHeight+'px'">
                    <KnowledgeTree :initTreeData="treeListData"></KnowledgeTree>
                    
                </div>
                
                <div v-else-if="pageSet.list_template=='tree_list'" :style="'height:'+tableMaxHeight+'px'">
                    <el-tree v-if="treeListData.length > 0"
                        :data="treeListData"
                        :props="{children: 'children',label: 'name'}"
                        node-key="id"
                        default-expand-all
                        :expand-on-click-node="false" class="LineTree">
                        <span class="custom-tree-node outLineTree" slot-scope="{ node, data }">
                            <span class="TreeName">{{data.name}}</span>
                            
                        </span>
                        </el-tree>
                </div>-->
            </div>
            <!-- fullscreen -->
            <el-dialog v-if="listDialogFlag"
                :title="listDialogTitle"
                :visible.sync="listDialogFlag"
                width=98%
                top="1vh"
                center
                >
                <span v-if="listDialogPageType == 5 || listDialogPageType == 7 ||
                    listDialogPageType == 8 || listDialogPageType == 11">
                    <AddOrUpPage :ref="'listDialog_'+dialogPageInfo.pageId" :initPageInfo="dialogPageInfo" 
                        @disableListSaveButton='disableListSaveButton'
                        @cancelListDialog='cancelListDialog'
                        @initSearchData="initSearchData" 
                        @zdyParentFun = "zdyParentFun"
                    ></AddOrUpPage>
                </span>
                <span v-if="listDialogPageType == 30"> 
                    <!-- {{dialogPageInfo.componentsHtml}} -->
                    <TimeTable :ref="'listDialog_'+dialogPageInfo.pageId" :info="dialogPageInfo"
                        @cancelListDialog='cancelListDialog'
                    >
                    </TimeTable>
                </span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelListDialog">取 消</el-button>
                    <el-button v-if="listDialogPageType == 5 || listDialogPageType == 7 ||
                        listDialogPageType == 8 || listDialogPageType == 30"
                        type="primary" @click="saveListDialog"
                        v-loading="listDialogLoading"
                    >保存</el-button>
                </span>
            </el-dialog>
        </el-main>
    </el-container>
  
</template>

<script>

import utils from '@/js/page/pageUtil.js'

import ListSearch from '@/components/page/ListSearch.vue'
import Schedule from '@/components/page/Schedule.vue'



export default {
  name: 'ListPage',
  data(){
      return{
        //弹出层的打开状态
        listDialogFlag:false,
        //弹出层打开的内容类型
        listDialogPageType:0,
        //弹出层打开的弹出层的名称
        listDialogTitle:"弹出层",
        //弹出层的加载框是否显示
        listDialogLoading:false,
        //加载框是否显示
        loading:false,
        //搜索条件设置的字段信息
        searchSetArr:[],
        //列表显示列设置的字段信息
        fieldSet:[],
        //加号展开的子表格当前的选中值 可以默认选中第一个
        childTabActiveName:'childTab_0',
        //页面的设置的字段信息
        pageSet:{
            //搜索条件是否默认展开 默认为否
            ifUnfoldsrch:"1",
            //是否统计记录数  默认为是
            ifSearchCount:0,
            //是否支持空闲时间搜索
            ifFreeTimeSearch:0,
            //左侧树pageId
            leftTreePageId:0,
            //左侧树的tableId
            leftTreeTableId:0,
            //左侧树点击时联动搜索右侧列表时的传递后台的条件插件
            leftTreeTjPlugId:0,
            //点击加号的子表格信息
            childTabs:[],
            operaButtonSet:[]
        },
        //当前加载的页面的列表数据
        listData:[],
        treeListData:[],
        //页面数据总数
        totalCount:0,
        //当前页面数据是第几个页面
        currentPage:1,
        //分页条数 默认是20条
        pageSize:20,
        //排序字段名称
        sortBy:null,
        //排序规则
        sortDir:null,
        //当前选中的数据
        selectionNodes:[],
        //列表的最大高度
        tableMaxHeight:450,
        pageInfo:{}
      }
  },
  
  methods:{

    formatterOperaButton(row, column) {
        console.log("row====================",row);
        console.log("column====================",column);
    },
    /**
     * 根据设置的样式进行行的样式返回 
     * 现在主要是设置的行颜色
     */
    getRowStyle({row, rowIndex}) {
        var rowData = row;
        var rowColorSet = this.pageSet.rowColorSet;
        if(rowColorSet != null && rowColorSet != undefined) {
            var colorStr = "";
            rowColorSet.forEach(element => {
                if(eval(element.jsWhereStr)) {
                    colorStr = element.color
                }
            });
            if(colorStr != "") {
                return "background: #"+colorStr;
            }
        }
        
        //background: #f0f9eb;
    },
    /**
     * 根据设置的单元格进行单元格的样式返回 
     * 现在主要是设置的列颜色
     */
    getCellStyle(json) {
        var columnInitLength = 3;
        if(this.pageSet.childTabs.length > 0) {
            columnInitLength = 4;
        }
        if(!this.pageSet.operaButtonSetIfHide) {
            columnInitLength = columnInitLength-1; 
        }
        /**
         * 列表数据显示列
         */
        var nowColumnIndex = json.columnIndex - columnInitLength;
        if(nowColumnIndex >= 0) {
            //获取列的设置信息
            var columnOne = this.fieldSet[nowColumnIndex];
            if(columnOne != null) {
                var rowData = json.row;
                var rowColorSet = columnOne.fieldTjSet;
                var colorStr = "";
                if(columnOne.defaultColor != null && columnOne.defaultColor != undefined && columnOne.defaultColor.length > 0) {
                    colorStr = columnOne.defaultColor;
                }
                if(rowColorSet != null && rowColorSet != undefined) {
                    rowColorSet.forEach(element => {
                        if(eval(element.jsWhereStr)) {
                            colorStr = element.color
                        }
                    });
                }
                if(colorStr != "") {
                    return "color: #"+colorStr;
                }
            }
        } else if(nowColumnIndex == -1) {
            //操作按钮列 进行按钮显示条件的判断


        }
    },

    /**
     * 表格行单击时，进行复选框的勾选和取消
     */
    tableRowClick(row, event, column){
        this.$refs.listTableRef.toggleRowSelection(row);
    },
    tableRowDblclick(row, event) {
        //双击时 判断如果是单选 则双击的默认选中并关闭弹出层
        if(this.pageInfo.dataMaxNum == 1) {
            this.selectionNodes = [row];
            //调用父级的选中方法
            this.$emit("closeListDialog");
        }
    },
    /**
     * 列表复选框勾选和取消时进行 选中个数的判断 不可大于最大选中个数
     */
    tableSelectionChange(selection){
        //判断选中个数 是否已经达到最大个数要求 如果达到则把最后选中的 取消掉
        if(this.pageInfo.dataMaxNum != undefined && this.pageInfo.dataMaxNum > 0 && selection.length > this.pageInfo.dataMaxNum) {
            if(this.pageInfo.dataMaxNum == 1) {

            }
            this.$message({
                message: '最多可以选中'+this.pageInfo.dataMaxNum+"个!",
                type: 'warning'
            });
            var tmpLength = selection.length;
            for(var i = 0; i < (tmpLength-this.pageInfo.dataMaxNum); i++) {
                this.$refs.listTableRef.toggleRowSelection(selection[i],false);
                selection.splice(i,1);
            }
        }
        this.selectionNodes = selection;
    },
    /**
     * 当点击列表统一操作按钮时触发
     * listDialogFlagType:弹出层页面类型
     * 1：列表页面
     * 5：添加页面
     * 7：修改页面
     * 8：批量修改页面
     * 11：查看页面
     * 15：弹出层页面
     */
    listButtonSetClick(buttonSetIndex){
        var buttonSetOne = this.pageSet.buttonSet[buttonSetIndex];
        var buttonType = buttonSetOne.buttonType;
        var startTurnPage = buttonSetOne.startTurnPage;
        var tableId = buttonSetOne.tableId;
        var buttonName = buttonSetOne.buttonName;
        //列表tableId
        var listTableId = this.pageInfo.tableId;
        var dialogPageInfo = {};
        if(buttonType == 0) {
            this.listDialogFlag = true;
            this.listDialogTitle = buttonName;
            //添加按钮
            this.listDialogPageType = 5;
            dialogPageInfo.pageType = 5;
            dialogPageInfo.pageId = startTurnPage;
            dialogPageInfo.tableId = tableId;
        } else if(buttonType == 2) {
           
            var selectionNodes = this.selectionNodes;
            var checkedId = '';
            selectionNodes.forEach(element => {
                if (checkedId != '') {
                    checkedId += ',';
                }
                checkedId += element["T_"+listTableId+"_0"];
            });
            if (checkedId == "") {
                this.$message({
                    showClose: true,
                    message: '请选中需要批量修改的数据,再进行操作!',
                    type: 'error'
                });
            } else {
                this.listDialogFlag = true;
                this.listDialogTitle = buttonName;
                //批量修改按钮
                this.listDialogPageType = 8;
                dialogPageInfo.pageType = 8;
                dialogPageInfo.pageId = startTurnPage;
                dialogPageInfo.tableId = tableId;
                dialogPageInfo.initMainDataId = checkedId;
            }

        } else if(buttonType == 3) {
            //批量删除按钮  获取选中的数据
            var selectionNodes = this.selectionNodes;
            var checkedId = '';
            selectionNodes.forEach(element => {
                if (checkedId != '') {
                    checkedId += ',';
                }
                checkedId += element["T_"+listTableId+"_0"];
            });
            this.deleteDataById(checkedId, buttonType);
        } else if(buttonType == 4) {
            //导入按钮

        } else if(buttonType == 5) {
            //导出按钮

        }
        this.dialogPageInfo = dialogPageInfo;
    },
    /**
     * 列表按钮点击时触发事件
     */
    dataButtonSetClick(operaButtonOne,rowData){
        //按钮类型
        var buttonType = operaButtonOne.buttonType;
        //打开的页面ID
        var startTurnPage = operaButtonOne.startTurnPage;
        //打开页面的tableId
        var tableId = operaButtonOne.tableId;
        //按钮名称
        var buttonName = operaButtonOne.buttonName;
        //关联字段
        var relationField = operaButtonOne.relationField;
        //列表tableId
        var listTableId = this.pageInfo.tableId;
        //列表的pageId
        var listPageId = this.pageInfo.pageId;

        var dialogPageInfo = {};
        if(buttonType == 12) {
            //修改页面
            dialogPageInfo = this.openListDialog(7,buttonName,startTurnPage,tableId,rowData[relationField],listTableId);
            console.log("dialogPageInfo==========",dialogPageInfo);
            
        } else if(buttonType == 18) {
            //关联添加页面
            dialogPageInfo = this.openListDialog(5,buttonName,startTurnPage,tableId,rowData[relationField],listTableId);
        } else if(buttonType == 15) {
            dialogPageInfo = this.openListDialog(11,buttonName,startTurnPage,tableId,rowData[relationField],listTableId);
        }  else if (buttonType == 13) {
            //删除
            this.deleteDataById(rowData["T_"+listTableId+"_0"], buttonType);
        } else if (buttonType == 21) {
            //直接操作按钮
            var directSetIds = operaButtonOne.directSetIds;
            //提示信息
            var operaPrompt = operaButtonOne.operaPrompt;
            this.dicrectTrigger(rowData["T_"+listTableId+"_0"], buttonType, directSetIds, operaPrompt, listTableId);
        } else if(buttonType == 19) {
            //自定义操作时 进行模板引用
            this.listDialogFlag = true;
            this.listDialogTitle = buttonName;
            //查看按钮
            this.listDialogPageType = 30;
            dialogPageInfo.listTableId = listTableId;
            dialogPageInfo.listPageId = listPageId;
            dialogPageInfo.initMainDataId = rowData[relationField];
            //自定义操作的 请求地址 由 组件名称和固定参数(例如请求数据的tableId 和 pageId组成)
            var startTurnPageUrl = operaButtonOne.startTurnPageUrl;

            var tmpArr = startTurnPageUrl.split("?");
            var componentsName = startTurnPageUrl.split("?")[0];
            var fixParam = "";
            if(tmpArr.length > 1) {
                fixParam = startTurnPageUrl.split("?")[1];
            }
            //自定义操作跳转的页面地址 改成
            dialogPageInfo.componentsHtml = "<"+componentsName+" :info='dialogPageInfo' ></" + componentsName + ">";
            console.log("dialogPageInfo=======================",dialogPageInfo);
            //固定参数
            dialogPageInfo.fixParam = fixParam;
            //列表的数据信息
            dialogPageInfo.initData = rowData;

        }
        this.dialogPageInfo = dialogPageInfo;
    },
    //打开列表的弹出层(关联添加/修改/查看)
    openListDialog(pageType,buttonName,startTurnPage,tableId,initMainDataId,listTableId){
        var dialogPageInfo = {};
        this.listDialogFlag = true;
        this.listDialogTitle = buttonName;
        if(pageType == 7) {
            //修改按钮
            this.listDialogPageType = 7;
            dialogPageInfo.pageType = 7;
            dialogPageInfo.pageId = startTurnPage;
            dialogPageInfo.tableId = tableId;
            dialogPageInfo.initMainDataId = initMainDataId;
        } else if(pageType == 5) {
            //关联添加
            this.listDialogPageType = 5;
            dialogPageInfo.pageType = 5;
            dialogPageInfo.pageId = startTurnPage;
            dialogPageInfo.tableId = tableId;
            dialogPageInfo.initMainDataId = initMainDataId;
            //列表的tableId
            dialogPageInfo.mainTableId = listTableId;
        } else if(pageType == 11) {
            //查看按钮
            this.listDialogPageType = 11;
            dialogPageInfo.pageType = 7;
            dialogPageInfo.pageId = startTurnPage;
            dialogPageInfo.tableId = tableId;
            dialogPageInfo.initMainDataId = initMainDataId;
        }
        return dialogPageInfo;
    },
    /**
     * 点击保存按钮时，进行数据保存
     */
    saveListDialog(){
        //进行 添加页面的验证 
        this.$refs['listDialog_'+this.dialogPageInfo.pageId].checkFormRules();
    },
    /**
     * 直接操作的方法
     */
    dicrectTrigger(nowDataId, buttonType, directSetIds, operaPrompt, listTableId){
        var that = this;
        if (operaPrompt == "" || operaPrompt == undefined) {
            operaPrompt = "确定要进行操作么？";
        }
        this.$confirm(operaPrompt, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            var tableId = that.pageInfo.tableId;
            var pageId = that.pageInfo.pageId;
            var url = "/update_dicrectTrigger.do";
            //进行后台直接操作
            var toHtData = {};
            toHtData.tableId = tableId;
            toHtData.pageId = 0;
            toHtData.directSetIds = directSetIds;
            toHtData.dataIds = nowDataId;
            toHtData.buttonType = buttonType;
            that.loading = true;
            that.$axios.post(url,toHtData).then(res => {
                that.loading = false;
                if (res.data != null) {
                    that.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    //刷新列表
                    that.initSearchData();
                }
            }).catch(error => {
                that.loading = false;
                that.$message({
                    type: 'info',
                    message: '操作失败'
                });  
            })
             
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消操作'
            });          
        });
    },
    /**
     * 点击删除时进行数据删除
     */
    deleteDataById(checkedId, buttonType){
        var that = this;
        if (checkedId == "") {
            this.$message({
                showClose: true,
                message: '请选中需要删除的数据,再进行删除操作!',
                type: 'error'
            });
        } else {
            this.$confirm('此操作将永久删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var tableId = that.pageInfo.tableId;
                var pageId = that.pageInfo.pageId;
                var url = "/delete_delete.do";
                //进行后台数据删除
                var toHtData = {};
                toHtData.tableId = tableId;
                toHtData.pageId = pageId;
                toHtData.delIds = checkedId;
                toHtData.buttonType = buttonType;
                that.loading = true;
                this.$axios.post(url,toHtData).then(res => {
                    that.loading = false;
                    if (res.data != null) {
                        that.$message({
                            type: 'success',
                            message: res.data
                        });
                        //刷新列表
                        that.initSearchData();
                    }
                }).catch(error => {
                    that.loading = false;
                    this.$message({
                        type: 'info',
                        message: '删除失败'
                    });  
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    },
    /**
     * 点击取消时，关闭弹出层
     */
    cancelListDialog() {
        this.listDialogFlag = false;
    },
    /**
     * 禁用保存按钮
     */
    disableListSaveButton(flag) {
        this.listDialogLoading = flag;
    },

    /**
     * 点击搜索按钮时进行后台数据搜索
     */
    initSearchData(){
        //切换分页条数时  默认显示第一页
        this.totalCount = 0;
        this.currentPage = 1;
        this.searchData();
    },

    /**
     * 进行后台数据搜索
     */
    searchData() {
        var that = this;
        //打开遮罩层
        this.loading = true;
        if(this.selectionNodes.length > 0) {
            this.selectionNodes = [];
            this.$refs.listTableRef.clearSelection();
        }
        //获取页面ID
        var pageId = this.pageInfo.pageId;
        //获取对象ID
        var tableId = this.pageInfo.tableId;

        //获取页面分页条数 默认20
        var pageSize = this.pageSize;
        //获取当前是第几页 默认第一页
        var currentPage = this.currentPage;

        this.pageSet.ifUnfoldsrch = "0";

        var pageSet = this.pageSet;

        var toHtData = {};
        //分页信息 
        toHtData.start = pageSize*(currentPage-1);
        toHtData.limit = pageSize + "_flow";
        //tableId 表id
        toHtData.tableId = tableId;
        //pageId 页面id
        toHtData.pageId = pageId;

        // //ctType=-1 报表或者消息穿透页面类型 暂时默认为 -1 之后如果做报表穿透再启用
        var ctType = this.pageInfo.ctType;
        if (ctType != null) {
            toHtData.ctType = ctType;
        } else {
            toHtData.ctType = -1;
        }

        // //SourceDataId 报表或者消息 穿透页面的过滤条件
        var SourceDataId = this.pageInfo.SourceDataId;
        if (SourceDataId != null) {
            toHtData.SourceDataId = SourceDataId;
        }
        //报表穿透时的where条件
        var whereCond = this.pageInfo.whereCond
        if(whereCond) {
            toHtData.whereCond = whereCond;
        }

        var mainId = this.mainId;
        console.log("mainId=================================",mainId);
        if(mainId != null && mainId > 0) {
            toHtData.mainId = mainId;
        }
        var sourcePageInfo = this.sourcePageInfo;
        console.log("sourcePageInfo=================================",sourcePageInfo);
        if(sourcePageInfo != null && sourcePageInfo != undefined) {
            toHtData.mainTableId = sourcePageInfo.tableId;
            toHtData.mainPageId = sourcePageInfo.pageId;
        }
        
        //ifSpecialPage  sql优化是否开启  一般默认为开启
        if(this.pageSet.ifSpecialPage) {
            toHtData.ifSpecialPage = this.pageSet.ifSpecialPage;
        }
        //ifAjaxCount  是否ajax加载记录数 如果当前分页为第一页 则加载记录数设置为false  如果当前分页不为第一页则设置为true
        if (this.totalCount == 0 && this.pageSet.ifSearchCount == 0) {
            toHtData.ifAjaxCount = false;
        } else {
            toHtData.ifAjaxCount = true;
        }

        if(this.sortBy != null) {
            toHtData.sortBy = this.sortBy;
            toHtData.sortDir = this.sortDir;
        }
        var toHtSearchData = this.$refs.ListSearch.toHtSearchData;//this.toHtSearchData;
        //循环往后台传递 搜索条件的数据 vm.$refs.
        //判断是否有空闲时间搜索的筛选条件
        if(this.pageSet.ifFreeTimeSearch == 1) {
            var freeTimeSearchArr = toHtSearchData.freeTimeSearchArr; 
            if(freeTimeSearchArr != null && freeTimeSearchArr.length > 0) {
                toHtData.freeTime_6_andOr=[];
                toHtData.startDate_startDates_pld=[];
                toHtData.endDate_endDates_pld=[];
                toHtData.startTime_startDates_pld=[];
                toHtData.endTime_endDates_pld=[];
                toHtData.startWeek_startDates_pld=[];
                toHtData.endWeek_startDates_pld=[];
                freeTimeSearchArr.forEach(element => {
                    toHtData.freeTime_6_andOr.push(element.freeTime_6_andOr);
                    toHtData.startDate_startDates_pld.push(element.startDate_startDates_pld);
                    toHtData.endDate_endDates_pld.push(element.endDate_endDates_pld);
                    toHtData.startTime_startDates_pld.push(element.startTime_startDates_pld);
                    toHtData.endTime_endDates_pld.push(element.endTime_endDates_pld);
                    toHtData.startWeek_startDates_pld.push(element.startWeek_startDates_pld);
                    toHtData.endWeek_startDates_pld.push(element.endWeek_startDates_pld);
                });
            }
        }
        for (var key in toHtSearchData) {
            if(key != "freeTimeSearchArr") {
                if(typeof(toHtSearchData[key]) == "object" && toHtSearchData[key] != null) {
                    var tmpId = "";
                    toHtSearchData[key].forEach(element => {
                        if(tmpId != "") {
                            tmpId += ",";
                        }
                        tmpId += element;
                    });
                    toHtData[key] = tmpId; 
                } else {
                    toHtData[key] = toHtSearchData[key];
                }
            }
        }
        
        //判断是否有左侧树 并且是否有左侧树的选中值
        if(this.pageSet.leftTreePageId > 0 && this.pageSet.leftTreeTjPlugId > 0) {
            //获取左侧树的当前选中值
            if(this.$refs.LeftTree != null) {
                var leftTreeCheckId = this.$refs.LeftTree.nowCheckOneId;
                if(leftTreeCheckId != undefined && leftTreeCheckId > 0) {
                    toHtData["valuePlug_"+this.pageSet.leftTreeTjPlugId] = leftTreeCheckId;
                }
            }
        }

        //判断是否有过滤条件 或者 已选中排前面的条件 如果有 则传递到后台去 &valuePlug_27=1,20,21,22,23&orderDataId=1,24,25
        var tmpJsonData = this.pageInfo.tmpJsonData;
        if(tmpJsonData != null && tmpJsonData.length > 0) {
            var tmpJsonDataArr = tmpJsonData.split("&");
            for (let index = 0; index < tmpJsonDataArr.length; index++) {
                const element = tmpJsonDataArr[index];
                var elementArr = element.split("=");
                if(elementArr.length > 1) {
                    toHtData[elementArr[0]] = elementArr[1];
                }
            }
        }
        var nowCheckId = this.pageInfo.nowCheckId;
        if(nowCheckId != null && nowCheckId != undefined) {
            toHtData.orderDataId = nowCheckId;
        }
        if(pageSet.ifParent == 1) {
            toHtData.ifTree = 1;
        }
        var url = "/model_ajaxList.do?source=1";
        if(pageSet.tableType == 10) {
            url = "/mongoModel_ajaxList.do";
        }
        //进行后台数据搜索
        this.$axios.post(url,toHtData).then(res => {
            that.loading = false;
            if(pageSet.ifParent != 1) {
                //关闭遮罩层
                //赋值当前页的数据进行页面显示
                var dataRows = res.data.rows;
                if(pageSet.list_template=='tree_list') {
                    that.listData = utils.buildTree(dataRows);
                } else {
                    that.listData = dataRows;
                }
                console.log("that.listData===11111===========",that.listData);
                //判断是否有初始选中值 如果有初始选中值 则进行选中操作
                if(nowCheckId != null && nowCheckId != undefined) {
                    dataRows.forEach(element => {
                        if(((","+nowCheckId+",").indexOf(","+element.LMF_ID+","))>=0) {
                            that.$refs.listTableRef.toggleRowSelection(element,true);
                        }
                    });
                }
                //赋值分页页面总记录数
                if(res.data.total > 0) {
                    that.totalCount = res.data.total;
                } else if(that.pageSet.ifSearchCount == 1) {
                    that.totalCount = 9999999;
                }
            } else {
                var dataRows = res.data.rows;
                console.log("dataRows==============",dataRows);
                //that.treeListData = utils.buildTree(dataRows);
                that.listData = utils.buildTree(dataRows);
                console.log("that.listData=====22=========",that.listData);
            }
        }).catch(error => {
            console.log("=====" + error);
        })
    },
    /**
     * 分页条数切换时触发
     */
    handleSizeChange(val) {
        this.pageSize = val;
        //调用数据初始化搜索
        this.initSearchData();
    },
    /**
     * 选择分页 当前页时触发
     */
    handleCurrentChange(val) {
        this.currentPage = val;
        //调用数据搜索
        this.searchData();
    },
    /**
     * 列表的序列字段 根据分页页数进行计算
     */
    getListIndex(index) {
        return ((this.currentPage-1)*this.pageSize)+index+1;
    },
    /**
     * 切换排序时进行后台查询
     */
    sortChange(res) {
        if(res.prop == null) {
            this.sortBy = null;
            this.sortDir = null;
        } else {
            this.sortBy = res.prop;
            if(res.order == "ascending") {
                this.sortDir = 'asc'
            } else {
                this.sortDir = 'desc'
            }
        }
        //调用数据初始化搜索
        this.initSearchData();
    },
    
    /**
     * 初始如果为不加载记录数 则点击时进行记录数加载
     */
    loadPageDataCount(){
        var tmpPageSet = this.pageSet;
        tmpPageSet.ifSearchCount = 0;
        this.pageSet = tmpPageSet;
        this.initSearchData();
    },
    /**
     * 传递到页面的组合方法
     */
    zdyParentFun(json){
        //先调用关闭弹出层的方法 再打开某个按钮
        this.cancelListDialog();
        
        //数据主键   tableId pageId  
        this.$nextTick(function(){
            this.dialogPageInfo = this.openListDialog(json.pageType,json.buttonName,json.startTurnPage,json.tableId,json.initMainDataId,json.listTableId);
        });
    }
  },

  /**
   * 页面创建时 判断是否是路由跳转
   */
  created:function(){
    var that = this;
    //请求地址传递的参数
    var paramsJson = this.$route.query;
    console.log("paramsJson=================",this.$route);
    
    //判断是否有初始的试题显示类型 如果有则赋值给showType
    if(paramsJson.tableId) {
      that.pageInfo.tableId = paramsJson.tableId;
    }
    if(paramsJson.pageId) {
      that.pageInfo.pageId = paramsJson.pageId;
    }
    if(paramsJson.mainId) {
      that.mainId = paramsJson.mainId;
    }
    console.log("that.mainId=========",that.mainId);
    if(paramsJson.ctType) {
      that.pageInfo.ctType = paramsJson.ctType;
    }
    if(paramsJson.SourceDataId) {
      that.pageInfo.SourceDataId = paramsJson.SourceDataId;
    }
    if(paramsJson.whereCond) {
      that.pageInfo.whereCond = paramsJson.whereCond;
    }

    console.log("that.pageInfo=============",that.pageInfo);
    if(this.initPageInfo){
        this.pageInfo = this.initPageInfo;
    }
  },
  
  /**
   * 页面创建时 进行后台数据请求 请求页面设置信息 之后再做浏览器端缓存
   */
  beforeMount : function(){
    var that = this;
    //计算页面高度 设置表格的最大高度 tableMaxHeight
    var windowHeight = window.innerHeight-220;
    this.tableMaxHeight = windowHeight;
    
    var pageId = this.pageInfo.pageId;
    var url = "/wxXcxSet_interfaceToList.do?source=1";
    this.loading = true;
    this.$axios.post(url,{
        pageId: pageId
    }).then(res => {
        that.loading = false;
        if (res.data) {
            var resDataPageSet = res.data.pageSet;
            that.searchSetArr = resDataPageSet.fieldSet;
            //构建搜索时需要提交到后台的数据信息
            if(that.searchSetArr != null) {
                that.$refs.ListSearch.toHtSearchData = utils.initToHtSearchData(that);
            }
            that.fieldSet = resDataPageSet.listFieldSet;
            var tmpPageSet = that.pageSet;
            //搜索条件的面板 默认收起还是展开 
            tmpPageSet.ifUnfoldsrch = resDataPageSet.ifUnfoldsrch+"";
            //是否进行记录数的加载
            tmpPageSet.ifSearchCount = resDataPageSet.ifSearchCount;
            //是否支持空闲时间资源搜索
            tmpPageSet.ifFreeTimeSearch = resDataPageSet.ifFreeTimeSearch;
            //左侧树的信息
            tmpPageSet.leftTreePageId = resDataPageSet.leftTreePageId;
            tmpPageSet.leftTreeTableId = resDataPageSet.leftTreeTableId;
            tmpPageSet.leftTreeTjPlugId = resDataPageSet.leftTreeTjPlugId;
            //角色
            tmpPageSet.list_template = resDataPageSet.list_template;
            //前几列是固定的
            tmpPageSet.fixdRow = resDataPageSet.fixdRow;
            //列颜色设置 
            tmpPageSet.rowColorSet = resDataPageSet.rowColorSet;
            tmpPageSet.tableType = resDataPageSet.tableType;

            //是否是树形组件
            tmpPageSet.ifParent = resDataPageSet.ifParent;
            
            // //点击加号展开的子表格的设置信息
            if(resDataPageSet.childTabs) {
                tmpPageSet.childTabs = resDataPageSet.childTabs;
            }
            //列表页面操作按钮的数据信息

            var user_buttons = "";
            if(sessionStorage.user_buttons != undefined) {
                user_buttons = sessionStorage.user_buttons;
            }
            var loginUserId = 0;
            if(sessionStorage.loginInfo) {
                var loginInfo = JSON.parse(sessionStorage.loginInfo);
                loginUserId = loginInfo.USERID;
            }
            //循环页面按钮信息 判断是否有按钮权限 如果没有按钮权限则去除按钮 operaButtonSet
            var buttonSet = resDataPageSet.buttonSet;
            if (buttonSet && buttonSet != undefined) {
                tmpPageSet.buttonSet = buttonSet;
                buttonSet.forEach(element => {
                    var buttonId = element.buttonId;
                    if (user_buttons.indexOf("," + pageId + "_" + buttonId + ",") >= 0 || loginUserId == 0) {
                        element.ifShow = true;
                    } else {
                        element.ifShow = false;
                    }
                    if (element.ifRoleLimit == 1) {
                        element.ifShow = true;
                    }
                });
            }
            //循环列表数据按钮信息  判断是否有按钮权限 
            var operaButtonSet = resDataPageSet.operaButtonSet;
            tmpPageSet.operaButtonSetIfHide = false;
            if (operaButtonSet && operaButtonSet != undefined) {
                tmpPageSet.operaButtonSet = operaButtonSet;
                var ifShowTrueNum = 0;
                operaButtonSet.forEach(element => {
                    var buttonId = element.buttonId;
                    if (user_buttons.indexOf("," + pageId + "_" + buttonId + ",") >= 0 || loginUserId == 0) {
                        element.ifShow = true;
                        ifShowTrueNum++;
                    } else {
                        element.ifShow = false;
                    }
                    if (element.ifRoleLimit == 1) {
                        element.ifShow = true;
                        ifShowTrueNum++;
                    }
                    console.log("element.ifShow=====================" ,element.ifShow,loginUserId);
                });
                if (ifShowTrueNum > 0) {
                    tmpPageSet.operaButtonSetIfHide = true;
                }
            }


            
            that.pageSet = tmpPageSet;
            console.log("=============111============",resDataPageSet.ifDefaultLoad,(resDataPageSet.ifDefaultLoad==0));
            if(tmpPageSet.list_template != 'kb_list') {
                //是否默认加载数据
                if(resDataPageSet.ifDefaultLoad == 0) {
                    that.initSearchData();
                }
            }
        } else{
            //登陆失败
            this.$message({
                showClose: true,
                message: '页面信息获取失败了，请重试!',
                type: 'error'
            });
        }
    }).catch(error => {
        console.log("=====" + error);
    })
  },
  components:{
      ListSearch,
      Schedule
  },
  props: {
    /**
     * 页面信息   
     * tableId: 对象Id
     * pageId: 页面Id
     * nowCheckId:当前选中Id
     * tmpJsonData:关联的需要传递到后台的过滤条件
     * ctType:  ctType=-1 报表或者消息穿透页面类型 暂时默认为 -1 之后如果做报表穿透再启用
     */
    initPageInfo: Object,
    mainId: Number,
    /**
     * 关联来源页面的id 例如加号展开的页面传递主页面信息
     */
    sourcePageInfo: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
